import { FC } from "react";
import { launchEmbeddedSignUp } from "../../../util/facebook/action";
import Button from "../../../styles/components/Button";

const FBEmbeddedSignupTab: FC = () => {
  return (
    <>
      <Button
        className="btn btn-lg btn-primary fw-bolder"
        onClick={() => launchEmbeddedSignUp("amx")}
      >
        FB LOGIN!
      </Button>
      <br />
    </>
  );
};

export default FBEmbeddedSignupTab;
